import React, {useState} from 'react';
import {Button} from 'primereact/button';
import {Skeleton} from 'primereact/skeleton';
import {BlockUI} from 'primereact/blockui';
import {useMountEffect} from 'primereact/hooks';
import StorageHelper from '../../../../../../utils/storage-helper';

export default function ProductCarousel({moveToNextView, moveToPreviousView, userPolicyInput, setuserPolicyInput}) {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [allGroups, setallGroups] = useState([]);

    const moveNext = (selectedPlanID, selectedPlanName, selectedPlan,) => {
        setuserPolicyInput({
            ...userPolicyInput,
            selectedSubGroupPlan: selectedPlan,
            selectedPlanID: selectedPlanID,
            selectedPlanName: selectedPlanName,
            allGroups: allGroups
        });
        moveToNextView();
    };


    function getCategoryFromCurrentUrl() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const category = urlSearchParams.get('category');
        return category;
    }

    async function getActiveProducts() {
        try {
            const response = await fetch(process.env.REACT_APP_DOVESAPI + 'policy/products/active', {
                headers: {
                    Authorization: 'Bearer ' + StorageHelper.get('token'),
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();

            if (data.status === 'SUCCESS') {
                const categoryValue = getCategoryFromCurrentUrl();
                let filteredProducts = []
                if (data.responseBody && Array.isArray(data.responseBody)) {
                    let validGroups = data.responseBody.filter(group => group && group.easipolPolicySubGroup);
                    if (categoryValue !== null) {
                        filteredProducts = validGroups.filter(group => group.category?.toUpperCase() === categoryValue.toUpperCase());
                    } else {
                        filteredProducts = validGroups.map(group => group);
                    }
                }

                setProducts(filteredProducts);
                setLoading(false);
            } else {
                setLoading(false);
                console.error('Failed to fetch policy history:', data.message);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching policy history:', error);
        }
    }

    useMountEffect(() => {
        setLoading(true)
        getActiveProducts()
    }, []);

    const productTemplate = (group) => {
        return (
            <div style={{height: "30em"}} className="border-1 surface-border border-round m-2 text-center py-1 px-1">
                <div>
                    <div className="mb-3">
                        <img src={group.groupImageBannerUrl} alt={group.Description} className="w-1 shadow-2 rounded"
                             style={{width: '100%', height: 'auto'}}/>
                    </div>
                    <h4>{group.easipolPolicySubGroup.Description}</h4>
                    <div>
                        <Button className='justify-content-center text-center mt-4' size='large'
                                label={<><strong color='blue'>{"APPLY"}</strong></>} severity="info" rounded outlined
                                raised
                                onClick={() => {
                                    moveNext(group.easipolPolicySubGroup.SubGroupID, group.easipolPolicySubGroup.Description, group)
                                }}
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <BlockUI blocked={loading}>
                {loading ?
                    <div className="card">
                        <div className="border-round border-1 surface-border p-4 surface-card">
                            <div className="flex mb-3">
                                <Skeleton shape="circle" size="4rem" className="mr-2"></Skeleton>
                                <div>
                                    <Skeleton width="10rem" className="mb-2"></Skeleton>
                                    <Skeleton width="5rem" className="mb-2"></Skeleton>
                                    <Skeleton height=".5rem"></Skeleton>
                                </div>
                            </div>
                            <Skeleton width="100%" height="150px"></Skeleton>
                            <div className="flex justify-content-between mt-3">
                                <Skeleton width="4rem" height="2rem"></Skeleton>
                                <Skeleton width="4rem" height="2rem"></Skeleton>
                            </div>
                        </div>
                    </div> :
                    <div className="container mx-auto px-4 max-w-7xl mb-12">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {products.map((group, index) => (
                                <div key={index}
                                     className="card bg-base-100 shadow-[0_8px_30px_rgb(0,0,0,0.08)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.16)] transition-all duration-300 border border-base-200/60 overflow-hidden flex flex-col h-[28rem] group">
                                    <figure className="h-56 w-full relative overflow-hidden">
                                        <img
                                            src={group.groupImageBannerUrl}
                                            alt={group.easipolPolicySubGroup.Description}
                                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                        />
                                        <div
                                            className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                                    </figure>
                                    <div
                                        className="card-body items-center text-center px-6 py-6 flex flex-col flex-grow bg-base-100">
                                        <h2 className="card-title text-lg font-extrabold uppercase tracking-wide text-base-content mb-2 line-clamp-2">
                                            {group.easipolPolicySubGroup.Description}
                                        </h2>
                                        <p className="text-sm text-base-content/60 mb-6 flex-grow line-clamp-3">Comprehensive
                                            funeral cover and services tailored for you and your family.</p>

                                        <div className="card-actions w-full mt-auto">
                                            <button
                                                className="btn btn-primary btn-outline w-full rounded-full shadow-md hover:shadow-lg transition-all font-bold tracking-wide"
                                                onClick={() => {
                                                    moveNext(group.easipolPolicySubGroup.SubGroupID, group.easipolPolicySubGroup.Description, group)
                                                }}
                                            >
                                                Apply Now
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                }
            </BlockUI>
        </>)
}